module.exports = __webpack_public_path__ + "media/images/lb/427-8d5ff20e81422747befd8dfb1e9ac929.svg";